module.exports = __webpack_public_path__ + "img/tv550x450.0ef397d1.png";